import { useBreakpoints } from '@vueuse/core'
import { theme } from '#tailwind-config'

export const useDisplay = () => {
  const breakpoints = useBreakpoints(theme.screens)
  const mdAndUp = breakpoints.greaterOrEqual('md')
  const mdAndDown = breakpoints.smallerOrEqual('md')
  const smAndUp = breakpoints.greaterOrEqual('sm')

  const breakpointsArray = [
    {
      name: 'xs',
      value: breakpoints.smallerOrEqual('sm'),
    },
    {
      name: 'sm',
      value: breakpoints.between('sm', 'md'),
    },
    {
      name: 'md',
      value: breakpoints.between('md', 'lg'),
    },
    {
      name: 'lg',
      value: breakpoints.between('lg', 'xl'),
    },
    {
      name: 'xl',
      value: breakpoints.between('xl', '2xl'),
    },
    {
      name: 'xxl',
      value: breakpoints.greaterOrEqual('2xl'),
    },
  ]
  let name = computed(() => breakpointsArray.find((item) => item.value.value)?.name)

  return {
    mdAndUp,
    mdAndDown,
    smAndUp,
    name,
  }
}
